// extracted by mini-css-extract-plugin
export default {"group":"Group_group__fuSGu"};